import { createApolloClient } from "../../services/apolloClient";
import { CheckPromoResponse, PromoCode } from "./types";
import { CHECK_PROMO_QUERY } from "./queries";

const getErrorMessage = (error: unknown, fallback: string) => {
  if (!error || typeof error !== "object") {
    return fallback;
  }

  const graphQLErrors = (
    error as { graphQLErrors?: Array<{ message?: string }> }
  ).graphQLErrors;

  if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
    const firstMessage = graphQLErrors[0]?.message;
    if (firstMessage) {
      return firstMessage.replace(/^Error:\s*/i, "");
    }
  }

  if (error instanceof Error && error.message) {
    return error.message.replace(/^Error:\s*/i, "");
  }

  return fallback;
};

const client = createApolloClient(true);

export const promoService = {
  async checkPromo(code: string): Promise<PromoCode[]> {
    try {
      const result = await client.query({
        query: CHECK_PROMO_QUERY,
        variables: { code },
        fetchPolicy: "no-cache",
      });

      const data = result.data as CheckPromoResponse | undefined;

      if (!data?.checkPromoCode || data.checkPromoCode.length === 0) {
        throw new Error("Promo check failed");
      }

      return data.checkPromoCode;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Promo check failed"));
    }
  },
};
